import { ColumnDef, createColumnHelper } from '@tanstack/react-table'
import React from 'react'
import CollapsableButtonGroup from '../../components/button/CollapsableButtonGroup'
import { Dashboard } from '../../shared/models/dashboard.model'
import TenantName from '../helper/TenantName'
import { Link } from 'react-router-dom'
import Flex from '../../components/common/Flex'
import { Dropdown } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { ActionRowProps } from '../../components/kopiliot-list/type'
import { PanelType } from '../../shared/models/panel'

const getColumnsForTableDashboard = (actionRows: ActionRowProps[]) => {
  const columnHelper = createColumnHelper<Dashboard>()
  const columns: ColumnDef<Dashboard, any>[] = [
    columnHelper.accessor((row) => row.id?.id, {
      id: 'id',
      cell: (info) => info.getValue(),
      header: () => 'Id',
      enableSorting: true,
    }),
    columnHelper.accessor((row) => row.name, {
      id: 'name',
      cell: (info) => {
        return (
          <h5 className={'mb-0 fs-10'}>
            <Link
              to={
                info.row.original.id?.id ? `${info.row.original.id?.id}` : '#'
              }
              className={'fw-semibold'}
            >
              {info.getValue()}
            </Link>
          </h5>
        )
      },
      header: () => 'Name',
      enableSorting: true,
    }),
    columnHelper.accessor((row) => row.description, {
      id: 'description',
      cell: (info) => info.getValue(),
      header: () => 'Description',
      enableSorting: false,
    }),
    columnHelper.display({
      id: 'tenantID',
      cell: (props) => {
        return (
          <>
            <TenantName tenantId={props.row.original.tenantID.id} />
          </>
        )
      },
      header: () => 'Tenant',
    }),
    columnHelper.display({
      id: 'actions',
      cell: (props) => {
        const customerID = props.row.original.id?.id
        return (
          <>
            {actionRows && customerID && (
              <Dropdown
                className={'text-center btn-reveal-trigger'}
                onClick={(event) => event.stopPropagation()}
              >
                <Dropdown.Toggle
                  size={'sm'}
                  className={'btn-reveal'}
                  variant="falcon-default"
                  id="dropdown-assets-actions"
                >
                  <FontAwesomeIcon icon={'ellipsis-h'} />
                </Dropdown.Toggle>

                <Dropdown.Menu
                  popperConfig={{ strategy: 'fixed' }}
                  renderOnMount={true}
                >
                  {actionRows.map((item) => {
                    return (
                      <Dropdown.Item
                        className={`text-${item.color || 'primary'}`}
                        key={item.title}
                        onClick={() => {
                          if (item.onClick) {
                            item.onClick(customerID)
                          }
                        }}
                      >
                        <FontAwesomeIcon
                          icon={item.icon}
                          className="fs-0 me-2"
                        />
                        {item.title}
                      </Dropdown.Item>
                    )
                  })}
                </Dropdown.Menu>
              </Dropdown>
            )}
          </>
        )
      },
      header: () => 'Actions',
    }),
  ]
  return columns
}

const defaultDashboardActionsRow = (
  onDeleteItem: (id: string) => void,
  onEditItem: (id: string) => void
) => {
  const actionsRow: ActionRowProps[] = [
    {
      title: 'Edit',
      color: 'primary',
      icon: 'edit',
      onClick: (id) => {
        onEditItem(id)
      },
    },
    {
      title: 'Delete',
      color: 'danger',
      icon: 'trash-alt',
      onClick: (id) => {
        onDeleteItem(id)
      },
    },
  ]
  return actionsRow
}

const getDefaultSettings = (type: PanelType) => {
  switch (type) {
    case PanelType.TIME_SERIES_LINE:
      return {
        responsive: true,
      }
    default:
      return {}
  }
}

export {
  getColumnsForTableDashboard,
  defaultDashboardActionsRow,
  getDefaultSettings,
}
